import { PAGES, DICTIONARIES, DICTIONARY_KEYNAME } from "@/common/consts";
import { readLocalStorage, writeLocalStorage } from "./localStorageUtils";

export const getDefaultDictionariesByPage = (routeName = "") => {
	if (typeof routeName !== "string") routeName = "";

	switch (routeName) {
		case PAGES.HOME:
		case PAGES.WWF:
		case PAGES.WORDS_CONSONANTS:
		case PAGES.WORDS_VOWELS:
		case PAGES.WORDS_ENDING_ING:
		case PAGES.WORDS_WITH_Q_NO_U:
		case PAGES.WORDS_BY_LENGTH_RESULTS:
		case PAGES.WORDS_ENDING_RESULTS:
		case PAGES.WORDS_HAVING_RESULTS:
		case PAGES.WORDS_STARTING_RESULTS:
			return DICTIONARIES[1];
		case PAGES.UNSCRAMBLE:
		case PAGES.WORD_DESCRAMBLER:
		case PAGES.WORD_UNSCRAMBLER:
		case PAGES.SCRABBLE_DICT:
		case PAGES.SCRABBLE_DICT_RESULTS:
		case PAGES.SCRABBLE_EXACTMATCH_RESULTS:
			return DICTIONARIES[2];
		case PAGES.WORDFEUD:
		case PAGES.WORD_CONNECT:
		case PAGES.WORDBRAIN_ANSWERS:
		case PAGES.WORD_STORY:
			return DICTIONARIES[4];
		case PAGES.WORD_CHUMS_CHEAT:
			return DICTIONARIES[6];
		case PAGES.UNSCRAMBLER_RESULTS:
			return DICTIONARIES[1];
		default:
			return DICTIONARIES[7];
	}
};

export const getDictionaries = () => {
	let dictionaryList = [];
	Object.entries(DICTIONARIES).forEach(([key]) =>
		dictionaryList.push({
			id: key,
			text: `DictionaryMenuSection${key}Text`,
			value: DICTIONARIES[key],
			titleAttribute: `DictionaryMenuSection${key}TitleAttribute`,
			ariaLabel: `DictionaryMenuSection${key}AriaLabel`,
			icon: `/static-wf/images/dictionary-icons/dict-${key}.png`,
		})
	);
	return dictionaryList;
};

export const getDictionaryByValue = (val) => {
	return getDictionaries().find((dict) => dict.value === val);
};

/**
 * Return true if the given route is or is under Scrabble Dictionary section
 * @param {String} routeName - A $route.name string
 * @return {Boolean} true if route is a results page; false otherwise.
 */
export const isScrabbleDictionaryPage = (routeName) => {
	return (
		routeName === PAGES.SCRABBLE_DICT ||
		routeName === PAGES.SCRABBLE_DICT_RESULTS ||
		routeName === PAGES.SCRABBLE_EXACTMATCH_RESULTS
	);
};

export const writeDictionary = (dictionary) => {
	writeLocalStorage(DICTIONARY_KEYNAME, dictionary);
};

export const readDictionary = (defaultValue = null) => {
	let dict = readLocalStorage(DICTIONARY_KEYNAME);

	// If the dictionary stored in Local Storage is no longer available, return the default value.
	if (
		!dict.length ||
		!Object.entries(DICTIONARIES).some((e) => e[1] === dict[0].dict)
	) {
		return defaultValue;
	}

	return dict[0].dict;
};

export const isScrabbleDictionary = (dictionary) => {
	return (
		dictionary.value === DICTIONARIES[2] ||
		dictionary.value === DICTIONARIES[3]
	);
};

export const isScrabbleDictResultsPage = (route) => {
	return route.name === PAGES.SCRABBLE_DICT_RESULTS;
};

export const isUnscrambleResultsPage = (route) => {
	return route.name === PAGES.UNSCRAMBLER_RESULTS;
};
